export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    settings: {},
    categories: [
      {
        'id': 'rulesoftheroad',
        'name': 'Rules of the Road',
        'iconName': require('../images/rulesoftheroad/icon_old.png'),
        browsable: false,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'Vessel port side with one black cylinder raised',
            'question': 'What is your action?',
            'short_description': 'Give way. Do not impede.',
            'long_description':'Vessel contrained by its draught.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-1.png')
          },
          {
            'id': 2, 
            'name': 'Head on',
            'question': 'What is your action?',
            'short_description': 'Alter Course',
            'long_description':'Alter course to Starboard.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-2.png')
          },
          {
            'id': 3, 
            'name': 'Vessel on starboard, potential collision.',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel crossing from starboard side is stand on vessel.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-3.png')
          },
          {
            'id': 4, 
            'name': 'Narrow channel',
            'question': 'What is your action?',
            'short_description': 'Keep to starboard side. Do not impede large vessels.',
            'long_description':'Do not anchor unless essential.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-4.png')
          },
          {
            'id': 5, 
            'name': 'Vessel on port side, potential collision.',
            'question': 'What is your action?',
            'short_description': 'Stand On',
            'long_description':'Vessel is crossing from port and should give way.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-5.png')
          },
          {
            'id': 6, 
            'name': 'Vessel on starboard side with one black cylinder raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is constrained by draught.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-6.png')
          },
          {
            'id': 7, 
            'name': 'Vessel on portside with Round/Diamond/Round shapes raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is restricted in its ability to manoeuver.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-7.png')
          },
          {
            'id': 8, 
            'name': 'Vessel on portside with two round shapes raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is Not Under Command.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-8.png')
          },
          {
            'id': 9, 
            'name': 'Vessel on portside with Blue/White flag raised',
            'question': 'What is your action?',
            'short_description': 'Stay Clear',
            'long_description':'Diver below. Stay well clear.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-9.png')
          },
          {
            'id': 10, 
            'name': 'Vessel on portside with two inverted cones',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is engaged in fishing.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-10.png')
          },
          {
            'id': 11, 
            'name': 'Sailing vessel on starboard side',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Power vessels gives way to sailing vessels.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-11.png')
          },
          {
            'id': 12, 
            'name': 'Vessel on portside with two round shapes raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is Not Under Command.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-12.png')
          },
          {
            'id': 13, 
            'name': 'Making way in narrow channel',
            'question': 'What is your action?',
            'short_description': 'Keep to starboard side of channel',
            'long_description':'Sound 1 long blast on horn.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-13.png')
          },
          {
            'id': 14, 
            'name': 'Narrow channel, planning to overtake on their starboard side',
            'question': 'What is your action?',
            'short_description': 'Sound Horn',
            'long_description':'2 long blasts and 1 short blast. Wait for response.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-14.png')
          },
          {
            'id': 15, 
            'name': 'Vessel crossing from starboard side',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel from starboard side is stand on vessel. ',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-15.png')
          },
          {
            'id': 16, 
            'name': 'Vessel on starboard side with Round/Diamond/Round shapes raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is restricted in its ability to manoeuver.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-16.png')
          },
          {
            'id': 17, 
            'name': 'Vessel on port side with one black cylinder raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is constrained by draught.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-17.png')
          },
          {
            'id': 18, 
            'name': 'Sailing vessel on starboard side',
            'question': 'What is your action?',
            'short_description': 'Stand On',
            'long_description':'Sailing vessels give way to vessels engaged in fishing.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-18.png')
          },
          {
            'id': 19, 
            'name': 'Vessel on portside side with one round ball raised',
            'question': 'What is your action?',
            'short_description': 'Keep Clear',
            'long_description':'Vessel under anchor. Vessel less than 100 metres.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-19.png')
          },
          {
            'id': 20, 
            'name': 'Sailing vessel on portside with inverted cone',
            'question': 'What is your action?',
            'short_description': 'Stand On',
            'long_description':'Sailing vessel under power. Vessels crossing on portside giveway.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-20.png')
          },
          {
            'id': 21, 
            'name': 'Vessel with obstruction over its starboard side',
            'question': 'What is your action?',
            'short_description': 'Keep clear and pass on portside of vessel',
            'long_description':'Vessel engaged in dredging. Restricted in ability to manoeuver. Obstacle on its starboard side. Pass on its portside.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-21.png')
          },
          {
            'id': 22, 
            'name': 'Vessel on starboard side with two round shapes raised',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel is Not Under Command.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-22.png')
          },
          {
            'id': 23, 
            'name': 'Vessel on ahead with two inverted cones raised plus 1 cone on the stern',
            'question': 'What is your action?',
            'short_description': 'Give Way',
            'long_description':'Vessel enganged in fishing with gear extending more than 150 from vessel.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-23.png')
          },
          {
            'id': 24, 
            'question': 'What is your action?',
            'name': 'Vessel with three round shapes raised',
            'short_description': 'Keep Clear',
            'long_description':'Vessel is aground.',
            'categories': ['rulesoftheroad'],
            'image640': require('../images/rulesoftheroad/rules1-24.png')
          },
        ]
      },
      {
        'id': "lights",
        'name': 'Navigation Lights',
        'iconName': require('../images/lights/icon_old.png'),
        browsable: false,
        score: 0,
        cards: [
          {
          'id': 1, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel under 50m towing partly submerged object',
          'long_description':'Power vessel under 50m towing partly submerged object less than 25m wide and less than 100m long as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-7.png')
          },
          {
          'id': 2, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m pushing another vessel',
          'long_description':'Power vessel probably over 50m pushing another vessel as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-8.png')
          },
          {
          'id': 3, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel less than 50m pushing another',
          'long_description':'Power vessel less than 50m pushing another as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-9.png')
          },
          {
          'id': 4, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel towing another',
          'long_description':'Power vessel towing another vessel as seen from astern.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-10.png')
          },
          {
          'id': 5, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Hover vessel',
          'long_description':'Hover vessel probably greater than 50m long operating in non-displacement mode as seen from starboard side.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-11.png')
          },
          {
          'id': 6, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m long towing another',
          'long_description':'Power vessel probably over 50m long towing another vessel with tow greater than 200m as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-12.png')
          },
          {
          'id': 7, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m long towing another vessel',
          'long_description':'Power vessel probably over 50m long towing another vessel as seen from portside. Tow less than 200m.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-6.png')
          },
          {
          'id': 8, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel less than 50m long towing another vessel',
          'long_description':'Power vessel less than 50m long towing another vessel as seen from starboard side. Tow less than 200m.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-5.png')
          },
          {
          'id': 9, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m long towing another vessel',
          'long_description':'Power vessel probably over 50m long towing another vessel as seen from starboard side. Tow greater than 200m.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-4.png')
          },
          {
          'id': 10, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m long towing another vessel',
          'long_description':'Power vessel probably over 50m long towing another vessel with tow greater than 200m. Restricted in ability to manoeuver making way as seen from starboard side.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-3.png')
          },
          {
          'id': 11, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m towing another vessel',
          'long_description':'Power vessel probably over 50m towing another vessel with length of tow less than 200m, making way as seen from bow.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-2.png')
          },
          {
          'id': 12, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel less than 50m towing another vessel',
          'long_description':'Power vessel less than 50m towing another vessel with length of tow less than 200m, making way as seen from bow.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights2-1.png')
          },
          {
          'id': 13, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel engaged in fishing',
          'long_description':'Vessel engaged in fishing other than trawling as seen from portside, making way.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-22.png')
          },
          {
          'id': 14, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Constrained by draught',
          'long_description':'Power vessel probably over 50m, constrained by draught, making way as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-21.png')
          },
          {
          'id': 15, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel probably over 50m',
          'long_description':'Power vessel probably over 50m making way as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-20.png')
          },
          {
          'id': 16, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Mine Clearing',
          'long_description':'Power vessel less than 50m making way as seen from bow, engaged in mine clearing.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-19.png')
          },
          {
          'id': 17, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Restricted in ability to manoeuver',
          'long_description':'Power vessel probably more than 50m making way as seen from starboard side, making way, restricted in ability to manoeuver.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-18.png')
          },
          {
          'id': 18, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Not under Command',
          'long_description':'Vessel not under command not making way.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-17.png')
          },
          {
          'id': 19, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel restricted in ability to manoeuver',
          'long_description':'Vessel restricted in ability to manoeuver, not making way, with obstruction on its left side. Clear to pass on right side.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-16.png')
          },
          {
          'id': 20, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Aground',
          'long_description':'Vessel probably over 50m aground.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-15.png')
          },
          {
          'id': 21, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel engaged in fishing',
          'long_description':'Vessel engaged in fishing other than trawling, not making way.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-14.png')
          },
          {
          'id': 22, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Fishing',
          'long_description':'Vessel engaged in fishing other than trawling, making way, as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-13.png')
          },
          {
          'id': 23, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Trawling',
          'long_description':'Vessel less than 50m engaged in trawling in close proximity to other fishing vessels with nets caught on obstuction, not making way.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-12.png')
          },
          {
          'id': 24, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Trawling in close proximity to other',
          'long_description':'Vessel less than 50m engaged in trawling in close proximity to other fishing vessels shooting nets, making way, as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-11.png')
          },
          {
          'id': 25, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel trawling',
          'long_description':'Vessel probably larger than 50m engaged in trawling, making way, as seen from the bow.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-10.png')
          },
          {
          'id': 26, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel trawling',
          'long_description':'Vessel probably larger than 50m engaged in trawling, making way, as seen from starboard side.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-9.png')
          },
          // {
          // 'id': 27, 
          // 'name': '',
          // 'question': 'What do the following lights signify?',
          // 'short_description': 'Trawling in close proximity to other fishing vessels',
          // 'long_description':'Vessel less than 50m engaged in trawling in close proximity to other fishing vessels hauling nets, making way, as seen from starboard side.',
          // 'categories': ['lights'],
          // 'image640': require('../images/lights/lights1-8.png')
          // },
          {
          'id': 28, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Purse Seine fishing hampered by gear',
          'long_description':'Vessel less than 50m engaged in purse seine fishing hampered by gear, making way, as seen from port side.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-7.png')
          },
          {
          'id': 29, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Stern light or Anchor Light',
          'long_description':'Could be Stern light, Anchor Light, Vessel under oars or Power vessel less than 7m.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-6.png')
          },
          {
          'id': 30, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Power vessel less than 50m',
          'long_description':'Power vessel less than 50m, making way, as seen from bow.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-5.png')
          },
          {
          'id': 31, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Sailing vessel',
          'long_description':'Sailing vessel under 20m.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-4.png')
          },
          {
          'id': 32, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Trawling.',
          'long_description':'Vessel engaged in trawling.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-3.png')
          },
          {
          'id': 33, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Vessel not under command',
          'long_description':'Vessel not under command, making way as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-2.png')
          },
          {
          'id': 34, 
          'name': '',
          'question': 'What do the following lights signify?',
          'short_description': 'Sailing Vessel',
          'long_description':'Sailing Vessel making way as seen from portside.',
          'categories': ['lights'],
          'image640': require('../images/lights/lights1-1.png')
          },
        ]
      },
      {
        'id': "iala",
        'name': "Iala Bouyage System 'A'",
        'iconName': require('../images/iala/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'Red Buoy',
            'question': 'What does the following marker signify?',
            'short_description': 'Port Lateral Marker',
            'long_description':'Blinking red light. Any frequency except 2 + 1.',
            'categories': ['iala'],
            'image640': require('../images/iala/lateral_port1.png')
          },
          {'id': 2, 'name': 'Red Buoy', 'question': 'What does the following marker signify?', 'short_description': 'Port Lateral Marker','long_description':'Blinking red light. Any frequency except 2 + 1.','categories': ['iala'],'image640': require('../images/iala/lateral_port2.png')},
          {'id': 3, 'name': 'Red Buoy','question': 'What does the following marker signify?','short_description': 'Port Lateral Marker','long_description':'Blinking red light. Any frequency except 2 + 1.','categories': ['iala'],'image640': require('../images/iala/lateral_port3.png')},
          {'id': 4, 'name': 'Green Buoy','question': 'What does the following marker signify?','short_description': 'Starboard Lateral Marker','long_description':'Blinking green light.','categories': ['iala'],'image640': require('../images/iala/lateral_starboard1.png')},
          {'id': 5, 'name': 'Green Buoy','question': 'What does the following marker signify?','short_description': 'Starboard Lateral Marker','long_description':'Blinking green light.','categories': ['iala'],'image640': require('../images/iala/lateral_starboard2.png')},
          {'id': 6, 'name': 'Green Buoy','question': 'What does the following marker signify?','short_description': 'Starboard Lateral Marker','long_description':'Blinking green light.','categories': ['iala'],'image640': require('../images/iala/lateral_starboard3.png')},
          {'id': 7, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - East','long_description':'East quadrant of hazard. Clear water to East. 3 very quick white flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_east1.png')},
          {'id': 8, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - East','long_description':'East quadrant of hazard. Clear water to East. 3 very quick wite flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_east2.png')},
          {'id': 9, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - North','long_description':'North quadrant of hazard. Clear water to North. Continuous quick white flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_north1.png')},
          {'id': 10, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - North','long_description':'North quadrant of hazard. Clear water to North. Continuous quick white flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_north2.png')},
          {'id': 11, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - West','long_description':'West quadrant of hazard. Clear water to West. 9 quick white flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_west1.png')},
          {'id': 12, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - West','long_description':'West quadrant of hazard. Clear water to West. 9 quick white flashes.','categories': ['iala'],'image640': require('../images/iala/cardinal_west2.png')},
          {'id': 13, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - South','long_description':'South quadrant of hazard. Clear water to South. 6 quick white flashes plus 1 long flash.','categories': ['iala'],'image640': require('../images/iala/cardinal_south1.png')},
          {'id': 14, 'name': 'Yellow/Black Buoy','question': 'What does the following marker signify?','short_description': 'Cardinal Marker - South','long_description':'South quadrant of hazard. Clear water to South. 6 quick white flashes plus 1 long flash.','categories': ['iala'],'image640': require('../images/iala/cardinal_south2.png')},
          {'id': 15, 'name': 'Red/White Buoy','question': 'What does the following marker signify?','short_description': 'Safe Water Marker','long_description':'Navigable water all around mark. White light occulting.','categories': ['iala'],'image640': require('../images/iala/clearwater1.png')},
          {'id': 16, 'name': 'Yellow/Blue Buoy','question': 'What does the following marker signify?','short_description': 'Emergency Wreck Marker','long_description':'Placed as close to wreck as possible or in a pattern around wreck. Alternating yellow/blue flashing light.','categories': ['iala'],'image640': require('../images/iala/emergencywreck1.png')},
          {'id': 17, 'name': 'Yellow/Blue Buoy','question': 'What does the following marker signify?','short_description': 'Emergency Wreck Marker','long_description':'Placed as close to wreck as possible or in a pattern around wreck. Alternating yellow/blue flashing light.','categories': ['iala'],'image640': require('../images/iala/emergencywreck2.png')},
          {'id': 18, 'name': 'Black/Red Buoy','question': 'What does the following marker signify?','short_description': 'Isolated Danger Marker','long_description':'Isolated danger of limited extent with navigable water around it. White flashing light with group of 2 flashes.','categories': ['iala'],'image640': require('../images/iala/isolateddanger1.png')},
          {'id': 19, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Port','long_description':'Preferred channel to port. Green group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_port1.png')},
          {'id': 20, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Port','long_description':'Preferred channel to port. Green group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_port2.png')},
          {'id': 21, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Port','long_description':'Preferred channel to port. Green group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_port3.png')},
          {'id': 22, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Starboard','long_description':'Preferred channel to starboard. Red group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_starboard1.png')},
          {'id': 23, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Starboard','long_description':'Preferred channel to starboard. Red group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_starboard2.png')},
          {'id': 24, 'name': 'Red/Green Buoy','question': 'What does the following marker signify?','short_description': 'Preferred Channel Marker - Starboard','long_description':'Preferred channel to starboard. Red group flashing light (2 + 1).','categories': ['iala'],'image640': require('../images/iala/preferred_starboard3.png')},
          {'id': 25, 'name': 'Yellow Buoy','question': 'What does the following marker signify?','short_description': 'Special Marker','long_description':'Refer to Chart. Yellow light, any frequency not used for white lights.','categories': ['iala'],'image640': require('../images/iala/special1.png')},
          {'id': 26, 'name': 'Yellow Buoy','question': 'What does the following marker signify?','short_description': 'Special Marker','long_description':'Refer to Chart. Yellow light, any frequency not used for white lights.','categories': ['iala'],'image640': require('../images/iala/special2.png')},
          {'id': 27, 'name': 'Yellow Buoy','question': 'What does the following marker signify?','short_description': 'Special Marker','long_description':'Refer to Chart. Yellow light, any frequency not used for white lights.','categories': ['iala'],'image640': require('../images/iala/special3.png')},
          {'id': 28, 'name': 'Yellow Buoy','question': 'What does the following marker signify?','short_description': 'Special Marker','long_description':'Refer to Chart. Yellow light, any frequency not used for white lights.','categories': ['iala'],'image640': require('../images/iala/special4.png')},
          {'id': 29, 'name': 'Yellow Buoy','question': 'What does the following marker signify?','short_description': 'Special Marker','long_description':'Refer to Chart. Yellow light, any frequency not used for white lights.','categories': ['iala'],'image640': require('../images/iala/special5.png')},
        
        ]
      },
      {
        'id': "lifesaving",
        'name': "Extinguisers",
        'iconName': require('../images/lifesaving/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'Red with Black stripe.',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Carbon Dioxide',
            'long_description':'Suitable for E-Class fires. Surpresses fires by diluting oxygen content of air.',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_carbondioxide.png')
            },
            {
            'id': 2, 
            'name': 'Red with White stripe.',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Dry Chemical',
            'long_description':'Usable for most types of fires. ',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_drychemical.png')
            },
            {
            'id': 3, 
            'name': 'Red with Blue stripe.',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Foam',
            'long_description':'Suitable for A and primarily B Class fires. Do not use where electrical hazard may exist ',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_foam.png')
            },
            {
            'id': 4, 
            'name': 'Red with Yellow stripe.',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Vapourising Liquid',
            'long_description':'Not suitable for F Class fire. Safe around electrics. Normally confined to Fixed systems.',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_vapourising.png')
            },
            {
            'id': 5, 
            'name': 'Red Extinguiser',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Water only.',
            'long_description':'Surpresses fire by removing heat from fuel. Suitable for A Class fires. Do not use where electrical hazard exist.',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_water.png')
            },
            {
            'id': 6, 
            'name': 'Red with Beige stripe.',
            'question': 'What does the following extinguisher signify?',
            'short_description': 'Wet Chemical',
            'long_description':'Suitable for F Class fires with vegetable oils and fats fire in galley.',
            'categories': ['fire_extinguishers'],
            'image640': require('../images/lifesaving/extinguiser_wetchemical.png')
            }
        ]
      },
      {
        'id': "flags",
        'name': "Flags",
        'iconName': require('../images/flags/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'White/Blue Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag A',
            'long_description':'Diver below, keep well clear.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_a.png')
          },
          {
            'id': 2, 
            'name': 'Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag B',
            'long_description':'I am taking in or carrying dangerous goods.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_b.png')
          },
          {
            'id': 3, 
            'name': 'Blue/White/Red Striped Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag C',
            'long_description':'Yes/affirmative.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_c.png')
          },
          {
            'id': 4, 
            'name': 'Yellow/Blue Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag D',
            'long_description':'Keep clear.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_d.png')
          },
          {
            'id': 5, 
            'name': 'Blue/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag E',
            'long_description':'I am altering my course to starboard.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_e.png')
          },
          {
            'id': 6, 
            'name': 'White/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag F',
            'long_description':'I am disabled, communicate with me.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_f.png')
          },
          {
            'id': 7, 
            'name': 'Yellow/Blue Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag G',
            'long_description':'I require a pilot. When made by fishing vessels operating in close proximity on the fishing grounds it means I am hauling nets.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_g.png')
          },
          {
            'id': 8, 
            'name': 'White/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag H',
            'long_description':'I have a pilot on board.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_h.png')
          },
          {
            'id': 9, 
            'name': 'Yellow/Black Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag I',
            'long_description':'I am altering my course to port.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_i.png')
          },
          {
            'id': 10, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag J',
            'long_description':'Keep well clear of me. I am on fire and have dangerous cargo on board.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_j.png')
          },
          {
            'id': 11, 
            'question': 'What does the following signify?',		
            'name': 'Yellow/Blue Flag',
            'short_description': 'Flag K',
            'long_description':'I wish to communicate with you.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_k.png')
          },
          {
            'id': 12, 
            'name': 'Yellow/Black Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag L',
            'long_description':'You should stop vessel instantly.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_l.png')
          },
          {
            'id': 13, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag M',
            'long_description':'My vessel is stopped and making no way through the water.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_m.png')
          },
          {
            'id': 14, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag N',
            'long_description':'No/negative.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_n.png')
          },
          {
            'id': 15, 
            'name': 'Yellow/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag O',
            'long_description':'Man overboard.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_o.png')
          },
          {
            'id': 16, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag P',
            'long_description':'In harbour. At sea, it may be used by fishing vessels to mean my nets have come fast upon an obstruction.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_p.png')
          },
          {
            'id': 17, 
            'name': 'Yellow Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag Q',
            'long_description':'My vessel is healthy and I request free pratique.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_q.png')
          },
          {
            'id': 18, 
            'name': 'Red/Yellow Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag R',
            'long_description':'The way is off my ship, you may feel your way past me.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_r.png')
          },
          {
            'id': 19, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag S',
            'long_description':'I am operating astern propulsion.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_s.png')
          },
          {
            'id': 20, 
            'name': 'Red/White/Blue Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag T',
            'long_description':'Keep clear of me, I am engaged in pair trawling.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_t.png')
          },
          {
            'id': 21, 
            'name': 'Red/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag U',
            'long_description':'You are running into danger.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_u.png')
          },
          {
            'id': 22, 
            'name': 'Red/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag V',
            'long_description':'I require assistance.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_v.png')
          },
          {
            'id': 23, 
            'name': 'Blue/White/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag W',
            'long_description':'I require medical assistance.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_w.png')
          },
          {
            'id': 24, 
            'name': 'Blue/White Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag X',
            'long_description':'Stop carrying out your intentions and watch for my signals.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_x.png')
          },
          {
            'id': 25, 
            'name': 'Red/Yellow Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag Y',
            'long_description':'I am dragging my anchor.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_y.png')
          },
          {
            'id': 26, 
            'name': 'Black/Yellow/Blue/Red Flag',
            'question': 'What does the following signify?',		
            'short_description': 'Flag Z',
            'long_description':'I require a tug. When made by fishing vessels operating in close proximity on the fishing grounds it means, I am shooting nets.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_z.png')
          },
          {
            'id': 27, 
            'question': 'What does the following signify?',		
            'name': 'Blue/White over Blue/White/Red',
            'short_description': 'Flag N over C',
            'long_description':'International Distress Signal.',
            'categories': ['flags'],
            'image640': require('../images/flags/flag_noverc.png')
          }
        ]
      },
      {
        'id': "dayshapes",
        'name': "Day Shapes",
        'iconName': require('../images/dayshapes/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': '3 Round Shapes',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel aground',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/aground.png')
          },
          {
            'id': 2, 
            'name': '1 Round Shape',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel at anchor',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/atanchor.png')
          },
          {
            'id': 3, 
            'name': '2 Facing Cones',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel engaged in fishing',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/fishing.png')
          },
          {
            'id': 4, 
            'name': '3 Round Shape In Triangular Positions',
            'question': 'What does this mast shape indicate?',		
            'short_description': 'Vessel engaged in mine sweeping',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/minesweeping.png')
          },
          {
            'id': 5, 
            'name': '2 Round Shapes',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel not under command',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/nuc.png')
          },
          {
            'id': 6, 
            'name': '3 Shapes - Round, Diamond, Round',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel restricted in ability to manoeuver',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/ram.png')
          },
          {
            'id': 7, 
            'question': 'What does this mast shape indicate?',
            'name': '1 Cylinder',
            'short_description': 'Vessel constrained by draught',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/restricteddraft.png')
          },
          {
            'id': 8, 
            'name': '2 Outward Facing Cones',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel towing. Tow exceeds 200m',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/towing.png')
          },
          {
            'id': 9, 
            'name': 'Downwards Cone',
            'question': 'What does this mast shape indicate?',
            'short_description': 'Vessel under sail but also under propulsion',
            'long_description':'',
            'categories': ['shapes'],
            'image640': require('../images/dayshapes/undersail.png')
          }
        ]
      },
      {
        'id': "soundsignals",
        'name': "Sound Signals",
        'iconName': require('../images/soundsignals/icon_old.png'),
        browsable: false,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': '1 Long Blast.',
            'question': 'What action do you take hearing below?',
            'short_description': 'Sound 1 Long blast where other vessels may be obscured by obstruction.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/1long.png')
          },
          {
            'id': 2, 
            'name': '1 Short Blast.',
            'question': 'What does the following signal mean?',
            'short_description': 'Altering course to starboard.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/1short.png')
          },
          {
            'id': 3, 
            'name': '2 Long and 1 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Intention to overtake on your starboard side.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/2long1short.png')
          },
          {
            'id': 4, 
            'name': '2 Long and 2 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Intention to overtake on your port side.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/2long2short.png')
          },
          {
            'id': 5, 
            'name': '2 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Altering course to port.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/2short.png')
          },
          {
            'id': 6, 
            'name': '3 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Operating astern propulsion.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/3short.png')
          },
          {
            'id': 7, 
            'name': '5 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'In doubt about signal intention or safety of the proposed manoeuvre.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/5short.png')
          },
          {
            'id': 8, 
            'name': 'Restricted Visibility - 1 Long Blast.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel making way through water.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_1long.png')
          },
          {
            'id': 9, 
            'name': 'Restricted Visibility - 2 Long Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Underway but stopped and making no way.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_2long.png')
          },
          {
            'id': 10, 
            'name': 'Restricted Visibility - 1 Long and 2 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel not under command, restricted in ability to manoeuver or constrained by draught.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_1long2short.png')
          },	
          {
            'id': 11, 
            'name': 'Restricted Visibility - 1 Long and 3 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel engaged in towing.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_1long3short.png')
          },	
          {
            'id': 12, 
            'name': 'Restricted Visibility - 4 Short Blasts.',
            'question': 'What does the following signal mean?',
            'short_description': 'Pilot vessel.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_4short.png')
          },	
          {
            'id': 13, 
            'name': 'Restricted Visibility - Rapid Bell.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel at anchor under 100 metres.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_rapidbell.png')
          },	
          {
            'id': 14, 
            'name': 'Restricted Visibility - Rapid Bell plus 3 distinct strokes on Bell.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel 100 metres long or greater, aground.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_rapidbell3distinct.png')
          },	
          {
            'id': 15, 
            'name': 'Restricted Visibility - Rapid Bell plus 3 distinct strokes on Bell plus rapid soundings of Gong.',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel aground at 100 metres or over.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/fog_rapidbell3distinctrapidgong.png')
          },	
          {
            'id': 16, 
            'name': '1 Long, 1 Short, 1 Long, 1 Short',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel indicating agreement to being overtaken.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/1long1short1long1short.png')
          },	
          {
            'id': 17, 
            'name': '1 Long, 1 Short, 1 Long, 1 Short',
            'question': 'What does the following signal mean?',
            'short_description': 'Vessel indicating agreement to being overtaken.',
            'long_description':'',
            'categories': ['soundsignals'],
            'image640': require('../images/soundsignals/1long1short1long1shortb.png')
          }
        ]
      },
      {
        'id': "phonetic",
        'name': "Phonetic Alphabet",
        'iconName': require('../images/phonetic/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'Phonetic A',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Alpha',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_a.png')
          },
          {
            'id': 2, 
            'name': 'Phonetic B',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Bravo',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_b.png')
          },
            {
            'id': 3, 
            'name': 'Phonetic C',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Charlie',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_c.png')
          },
            {
            'id': 4, 
            'name': 'Phonetic D',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Delta',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_d.png')
          },
          {
            'id': 5, 
            'name': 'Phonetic E',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Echo',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_e.png')
          },
          {
            'id': 6, 
            'name': 'Phonetic F',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Foxtrot',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_f.png')
          },
            {
            'id': 7, 
            'name': 'Phonetic G',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Golf',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_g.png')
          },
            {
            'id': 8, 
            'name': 'Phonetic H',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Hotel',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_h.png')
          },
            {
            'id': 9, 
            'name': 'Phonetic I',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'India',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_i.png')
          },
          {
            'id': 10, 
            'name': 'Phonetic J',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Juliet',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_j.png')
          },
            {
            'id': 11, 
            'name': 'Phonetic K',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Kilo',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_k.png')
          },
          {
            'id': 12, 
            'name': 'Phonetic L',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Lima',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_l.png')
          },
          {
            'id': 13, 
            'name': 'Phonetic M',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Mike',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_m.png')
          },
        {
            'id': 14, 
            'name': 'Phonetic N',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'November',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_n.png')
          },
          {
            'id': 15, 
            'name': 'Phonetic O',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Oscar',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_o.png')
          },
            {
            'id': 16, 
            'name': 'Phonetic P',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Papa',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_p.png')
          },
            {
            'id': 17, 
            'name': 'Phonetic Q',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Quebec',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_q.png')
          },
            {
            'id': 18, 
            'name': 'Phonetic R',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Romeo',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_r.png')
          },
          {
            'id': 19, 
            'name': 'Phonetic S',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Sierra',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_s.png')
          },
          {
            'id': 20, 
            'name': 'Phonetic T',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Tango',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_t.png')
          },
          {
            'id': 21, 
            'name': 'Phonetic U',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Uniform',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_u.png')
          },
            {
            'id': 22, 
            'name': 'Phonetic V',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Victor',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_v.png')
          },
            {
            'id': 23, 
            'name': 'Phonetic W',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Whiskey',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_w.png')
          },
          {
            'id': 24, 
            'name': 'Phonetic X',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Xray',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_x.png')
          },
          {
            'id': 25, 
            'name': 'Phonetic Y',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Yankee',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_y.png')
          },
          {
            'id': 26, 
            'name': 'Phonetic Z',
            'question': 'What is the phonetic word for character below?',
            'short_description': 'Zulu',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/phonetic/phonetic_z.png')
          }
        ]
      },
      {
        'id': "morse",
        'name': "Morse",
        'iconName': require('../images/morse/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': 'Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse A',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_a.png')
          },
            {
            'id': 2, 
            'name': 'Long, Short, Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse B',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_b.png')
          },
            {
            'id': 3, 
            'name': 'Long, Short, Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse C',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_c.png')
          },
            {
            'id': 4, 
            'name': 'Long, Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse D',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_d.png')
          },
            {
            'id': 5, 
            'name': 'Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse E',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_e.png')
          },
            { 
            'id': 6, 
            'name': 'Short, Short, Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse F',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_f.png')
          },
            {
            'id': 7, 
            'name': 'Long, Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse G',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_g.png')
          },
            {
            'id': 8, 
            'name': 'Short, Short, Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse H',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_h.png')
          },
            {
            'id': 9, 
            'name': 'Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse I',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_i.png')
          },
            {
            'id': 10, 
            'name': 'Short, Long, Long, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse J',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_j.png')
          },
            {
            'id': 11, 
            'name': 'Long, Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse K',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_k.png')
          },
            {
            'id': 12, 
            'name': 'Short, Long, Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse L',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_l.png')
          },
            {
            'id': 13, 
            'name': 'Long, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse M',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_m.png')
          },
            {
            'id': 14, 
            'name': 'Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse N',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_n.png')
          },
            {
            'id': 15, 
            'name': 'Long, Long, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse O',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_o.png')
          },
            {
            'id': 16, 
            'name': 'Short, Long, Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse P',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_p.png')
          },
            {
            'id': 17, 
            'name': 'Long, Long, Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse Q',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_q.png')
          },
            {
            'id': 18, 
            'name': 'Short, Long, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse R',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_r.png')
          },
            {
            'id': 19, 
            'name': 'Short, Short, Short',
            'question': 'What does the following code signify?',
            'short_description': 'Morse S',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_s.png')
          },
            {
            'id': 20, 
            'name': 'Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse T',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_t.png')
          },
            {
            'id': 21, 
            'name': 'Short, Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse U',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_u.png')
          },
            {
            'id': 22, 
            'name': 'Short, Short, Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse V',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_v.png')
          },
            {
            'id': 23, 
            'name': 'Short, Long, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse W',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_w.png')
          },
            { 
            'id': 24, 
            'name': 'Long, Short, Short, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse X',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_x.png')
          },
            {
            'id': 25, 
            'name': 'Long, Short, Long, Long',
            'question': 'What does the following code signify?',
            'short_description': 'Morse Y',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_y.png')
          },
            { 
            'id': 26, 
            'question': 'What does the following code signify?',
            'name': 'Long, Long, Short, Short',
            'short_description': 'Morse Z',
            'long_description':'',
            'categories': ['phonetic'],
            'image640': require('../images/morse/morse_z.png')
          }
        ]
      },
      {
        'id': "nautical_knowledge",
        'name': "Nautical Knowledge",
        'iconName': require('../images/nautical_knowledge/icon_old.png'),
        browsable: true,
        score: 0,
        cards: [
          {
            'id': 1, 
            'name': '',
            'question': 'What is the type of Anchor?',
            'short_description': 'Danforth',
            'long_description':'Good general purpose anchor and fits snuggly into hawse pipe.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_danforth.png')
          },
          {
            'id': 2, 
            'name': '',
            'question': 'What is the type of Anchor?',
            'short_description': 'Admiralty',
            'long_description':'Classic anchor. Outdated by more modern anchor.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_admiralty.png')
          },
          {
            'id': 3, 
            'name': '',
            'question': 'What is the type of Anchor?',
            'short_description': 'Bruce',
            'long_description':'Exceptionally strong, easy to handle and stow on bow roller.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_bruce.png')
          },
          {
            'id': 4, 
            'name': '',
            'question': 'What is the type of Anchor?',
            'short_description': 'CQR',
            'long_description':'Better holding power than older anchor designs. Generally used for small craft as it suits bow roller system. Good for all types of sand, mud and clay.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_cqr.png')
          },
          {
            'id': 5, 
            'question': 'What is the type of Anchor?',
            'name': '',
            'short_description': 'Reef',
            'long_description':'Used for short stops on reef, never leave over night. Anchor can pull free under extreme vertical pull.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_reef.png')
          },
          {
            'id': 6, 
            'name': '',
            'question': 'What is the type of Anchor?',
            'short_description': 'Stockless',
            'long_description':'Easily secured and quickly made ready for letting go. Less holding pull than Admiralty.',
            'categories': ['nautical_knowledge'],
            'image640': require('../images/nautical_knowledge/anchor_stockless.png')
          }
        ]
      }
    ]
  },
  action,
) {

  // Set payload specifics
  switch (action.type) {
    case 'FETCH_ALLSHIPS_SETTINGS_FULFILLED': {
      return {
        ...state,
        settings: action.payload
      };
    }

    case 'UPSERT_ALLSHIPS_SETTINGS_FULFILLED': {
      return {
        ...state,
        settings: action.payload
      };
    }

    case 'FETCH_ALLSHIPS_SCORES_FULFILLED': {
      const {categories} = state;

      action.payload.map(payload => {
        const idx = categories.findIndex(category => category.id === payload.id);
        if (idx > -1) categories[idx].score = payload.score;
      })

      return {
        ...state,
        categories
      };
    }
    
    case 'UPSERT_ALLSHIPS_SCORES_FULFILLED': {
      const {categories} = state;
      const idx = categories.findIndex(category => category.id === action.payload.id);
      categories[idx].score = action.payload.score;

      return {
        ...state,
        categories
      };
    }
    case 'CLEAR_ALLSHIPS_SCORES_FULFILLED': {
      const {categories} = state;
      const resetCategories = categories.map(category => ({...category, score: 0}));

      return {
        ...state,
        categories: resetCategories
      };
    }
    default:
      break;
  }
  return state;
}
